import { Howl, Howler } from 'howler';

export interface SoundConfig {
  src: string[];
  volume?: number;
  loop?: boolean;
}

export interface SoundLibrary {
  [key: string]: SoundConfig;
}

const SOUND_LIBRARY: SoundLibrary = {
  explosion1: {
    src: ['/sounds/Explosion1.wav'],
    volume: 0.7,
  },
  explosion2: {
    src: ['/sounds/Explosion2.wav'],
    volume: 0.7,
  },
  explosion3: {
    src: ['/sounds/Explosion3.WAV'],
    volume: 0.7,
  },
  grenadeBounce: {
    src: ['/sounds/GRENADEIMPACT.WAV'],
    volume: 0.5,
  },
  bananaBounce: {
    src: ['/sounds/BananaImpact.wav'],
    volume: 0.6,
  },
  bazookaFire: {
    src: ['/sounds/ROCKETRELEASE.WAV'],
    volume: 0.8,
  },
  rocketPowerUp: {
    src: ['/sounds/ROCKETPOWERUP.WAV'],
    volume: 0.5,
  },
  rocketPowerDown: {
    src: ['/sounds/ROCKETPOWERDOWN.wav'],
    volume: 0.5,
  },
  shotgunFire: {
    src: ['/sounds/ShotGunFire.wav'],
    volume: 1.0,
  },
  shotgunReload: {
    src: ['/sounds/SHOTGUNRELOAD.WAV'],
    volume: 1.0,
  },
  grenadeThrow: {
    src: ['/sounds/THROWRELEASE.WAV'],
    volume: 0.6,
  },
  throwPowerUp: {
    src: ['/sounds/THROWPOWERUP.WAV'],
    volume: 0.5,
  },
  throwPowerDown: {
    src: ['/sounds/THROWPOWERDOWN.wav'],
    volume: 0.5,
  },
  ropeShoot: {
    src: ['/sounds/NinjaRopeFire.wav'],
    volume: 0.6,
  },
  ropeAttach: {
    src: ['/sounds/NinjaRopeImpact.wav'],
    volume: 0.7,
  },
  teleport: {
    src: ['/sounds/TELEPORT.WAV'],
    volume: 1.0,
  },
  mineArm: {
    src: ['/sounds/MineArm.wav'],
    volume: 0.6,
  },
  mineTick: {
    src: ['/sounds/MINETICK.WAV'],
    volume: 0.5,
  },
  mineDud: {
    src: ['/sounds/MINEDUD.WAV'],
    volume: 0.6,
  },
  dynamiteFuse: {
    src: ['/sounds/FUSE.WAV'],
    volume: 0.5,
    loop: true,
  },
  airstrike: {
    src: ['/sounds/Airstrike.wav'],
    volume: 0.8,
  },
  wormJump: {
    src: ['/sounds/WORMSPRING.WAV'],
    volume: 0.5,
  },
  wormLanding: {
    src: ['/sounds/WormLanding.wav'],
    volume: 0.5,
  },
  wormImpact: {
    src: ['/sounds/WORMIMPACT.WAV'],
    volume: 0.6,
  },
  wormSelect: {
    src: ['/sounds/WORMSELECT.WAV'],
    volume: 0.6,
  },
  splash: {
    src: ['/sounds/Splash.wav'],
    volume: 0.8,
  },
  splish: {
    src: ['/sounds/Splish.wav'],
    volume: 0.6,
  },
  timerTick: {
    src: ['/sounds/TIMERTICK.WAV'],
    volume: 0.4,
  },
  turnStart: {
    src: ['/sounds/StartRound.wav'],
    volume: 0.6,
  },
  cursorSelect: {
    src: ['/sounds/CursorSelect.wav'],
    volume: 0.4,
  },
  communicator: {
    src: ['/sounds/Communicator.wav'],
    volume: 0.5,
  },
  collect: {
    src: ['/sounds/Collect.wav'],
    volume: 0.6,
  },
  walkExpand: {
    src: ['/sounds/Walk-Expand.wav'],
    volume: 0.3,
  },
  walkCompress: {
    src: ['/sounds/Walk-Compress.wav'],
    volume: 0.3,
  },
  ricochet: {
    src: ['/sounds/RICOCHET.WAV'],
    volume: 0.6,
  },
  parachute: {
    src: ['/sounds/Collect.wav'],
    volume: 0.6,
  },
  holyGrenade: {
    src: ['/sounds/HOLYGRENADE.WAV'],
    volume: 0.8,
  },
  holyGrenadeImpact: {
    src: ['/sounds/HOLYGRENADEIMPACT.WAV'],
    volume: 0.9,
  },
  armageddon: {
    src: ['/sounds/Armageddon.wav'],
    volume: 0.9,
  },
  suddenDeath: {
    src: ['/sounds/SUDDENDEATH.WAV'],
    volume: 0.9,
  },
  warningBeep: {
    src: ['/sounds/WARNINGBEEP.WAV'],
    volume: 0.6,
  },
  freeze: {
    src: ['/sounds/Freeze.wav'],
    volume: 0.6,
  },
  sizzle: {
    src: ['/sounds/SIZZLE.WAV'],
    volume: 0.5,
  },
  blowtorch: {
    src: ['/sounds/BlowTorch.wav'],
    volume: 0.6,
  },
  drill: {
    src: ['/sounds/DRILL.WAV'],
    volume: 0.6,
  },
  firePunchImpact: {
    src: ['/sounds/FirePunchImpact.wav'],
    volume: 0.7,
  },
  uzi: {
    src: ['/sounds/UZIFIRE.WAV'],
    volume: 0.6,
  },
  minigun: {
    src: ['/sounds/MiniGunFire.wav'],
    volume: 0.6,
  },
  handgun: {
    src: ['/sounds/HANDGUNFIRE.WAV'],
    volume: 0.6,
  },
  baseballHit: {
    src: ['/sounds/BaseBallBatImpact.wav'],
    volume: 0.7,
  },
  baseballRelease: {
    src: ['/sounds/BaseBallBatRelease.wav'],
    volume: 0.6,
  },
  baseballJingle: {
    src: ['/sounds/BaseBallBatJingle.wav'],
    volume: 0.7,
  },
  cough1: {
    src: ['/sounds/COUGH1.WAV'],
    volume: 0.6,
  },
  cough2: {
    src: ['/sounds/Cough2.wav'],
    volume: 0.6,
  },
  cough3: {
    src: ['/sounds/Cough3.wav'],
    volume: 0.6,
  },
  sheepBaa: {
    src: ['/sounds/SHEEPBAA.WAV'],
    volume: 0.6,
  },
  superSheepRelease: {
    src: ['/sounds/SUPERSHEEPRELEASE.WAV'],
    volume: 0.6,
  },
  superSheepWhoosh: {
    src: ['/sounds/SUPERSHEEPWHOOSH.WAV'],
    volume: 0.5,
    loop: true,
  },
  windGust: {
    src: ['/sounds/SUPERSHEEPWHOOSH.WAV'],
    volume: 0.55,
  },
  cowMoo: {
    src: ['/sounds/CowMoo.wav'],
    volume: 0.7,
  },
  pigeonCoo: {
    src: ['/sounds/PIGEONCOO.WAV'],
    volume: 0.6,
  },
  oldWoman: {
    src: ['/sounds/OLDWOMAN.WAV'],
    volume: 0.6,
  },
  holyDonkey: {
    src: ['/sounds/HOLYDONKEY.WAV'],
    volume: 0.8,
  },
  holyDonkeyImpact: {
    src: ['/sounds/HOLYDONKEYIMPACT.WAV'],
    volume: 0.9,
  },
  kamikaze: {
    src: ['/sounds/KAMIKAZERELEASE.WAV'],
    volume: 0.7,
  },
  longBowRelease: {
    src: ['/sounds/LongBowRelease.wav'],
    volume: 0.6,
  },
  longBowImpact: {
    src: ['/sounds/LongBowImpact.wav'],
    volume: 0.6,
  },
  homingLock: {
    src: ['/sounds/WEAPONHOMING.WAV'],
    volume: 0.7,
  },
  girderPlace: {
    src: ['/sounds/GIRDERIMPACT.WAV'],
    volume: 0.7,
  },
  jetpackStart: {
    src: ['/sounds/JetPackStart.wav'],
    volume: 0.6,
  },
  jetpackLoop: {
    src: ['/sounds/JetPackLoop1.wav'],
    volume: 0.4,
    loop: true,
  },
  jetpackFinish: {
    src: ['/sounds/JetPackFinish.wav'],
    volume: 0.6,
  },
};

const VOICE_SOUNDS: Record<string, string[]> = {
  hello: ['HELLO.WAV'],
  yessir: ['YESSIR.WAV'],
  orders: ['ORDERS.WAV'],
  ow: ['OW1.WAV', 'OW2.WAV', 'OW3.WAV'],
  ouch: ['OUCH.WAV'],
  ooff: ['OOFF1.WAV', 'OOFF2.WAV', 'OOFF3.WAV'],
  byebye: ['BYEBYE.WAV'],
  victory: ['VICTORY.WAV'],
  excellent: ['EXCELLENT.WAV'],
  perfect: ['PERFECT.WAV'],
  amazing: ['AMAZING.WAV'],
  brilliant: ['BRILLIANT.WAV'],
  flawless: ['FLAWLESS.WAV'],
  grenade: ['GRENADE.WAV'],
  fire: ['FIRE.WAV'],
  fireball: ['FIREBALL.WAV'],
  incoming: ['INCOMING.WAV'],
  hurry: ['HURRY.WAV'],
  takecover: ['TAKECOVER.WAV'],
  runaway: ['RUNAWAY.WAV'],
  watchthis: ['WATCHTHIS.WAV'],
  laugh: ['LAUGH.WAV'],
  boring: ['BORING.WAV'],
  bummer: ['BUMMER.WAV'],
  missed: ['MISSED.WAV'],
  stupid: ['STUPID.WAV'],
  oops: ['OOPS.WAV'],
  nooo: ['NOOO.WAV'],
  ohdear: ['OHDEAR.WAV'],
  uhoh: ['UH-OH.WAV'],
  whatthe: ['WHATTHE.WAV'],
  coward: ['COWARD.WAV'],
  traitor: ['TRAITOR.WAV'],
  revenge: ['REVENGE.WAV'],
  illgetyou: ['ILLGETYOU.WAV'],
  justyouwait: ['JUSTYOUWAIT.WAV'],
  youllregretthat: ['YOULLREGRETTHAT.WAV'],
  comeonthen: ['COMEONTHEN.WAV'],
  goaway: ['GOAWAY.WAV'],
  leavemealone: ['LEAVEMEALONE.WAV'],
  oinutter: ['OINUTTER.WAV'],
  collect: ['COLLECT.WAV'],
  drop: ['DROP.WAV'],
  bungee: ['BUNGEE.WAV'],
  kamikaze: ['KAMIKAZE.WAV'],
  dragonpunch: ['DRAGONPUNCH.WAV'],
  fatality: ['FATALITY.WAV'],
  firstblood: ['FIRSTBLOOD.WAV'],
  wobble: ['WOBBLE.WAV'],
  jump1: ['JUMP1.WAV'],
  jump2: ['JUMP2.WAV'],
};

const STORAGE_KEY = 'vvorms_sound_settings';

interface SoundSettings {
  masterVolume: number;
  voiceVolume: number;
  enabled: boolean;
}

function loadSoundSettings(): SoundSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        masterVolume: typeof parsed.masterVolume === 'number' ? parsed.masterVolume : 0.5,
        voiceVolume: typeof parsed.voiceVolume === 'number' ? parsed.voiceVolume : 0.5,
        enabled: typeof parsed.enabled === 'boolean' ? parsed.enabled : true,
      };
    }
  } catch {
    /* noop */
  }
  return { masterVolume: 0.5, voiceVolume: 0.5, enabled: true };
}

class SoundManager {
  private sounds: Map<string, Howl> = new Map();
  private voices: Map<string, Howl[]> = new Map();
  private enabled: boolean;
  private masterVolume: number;
  private voiceVolume: number;
  private voicePack: string = 'Portuguese';
  private firstBloodPlayed: boolean = false;

  constructor() {
    const saved = loadSoundSettings();
    this.masterVolume = saved.masterVolume;
    this.voiceVolume = saved.voiceVolume;
    this.enabled = saved.enabled;
    Howler.volume(this.masterVolume);
  }

  private saveSettings(): void {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          masterVolume: this.masterVolume,
          voiceVolume: this.voiceVolume,
          enabled: this.enabled,
        }),
      );
    } catch {
      /* noop */
    }
  }

  async init(): Promise<void> {
    for (const [name, config] of Object.entries(SOUND_LIBRARY)) {
      const howl = new Howl({
        src: config.src,
        volume: (config.volume ?? 1.0) * this.masterVolume,
        loop: config.loop ?? false,
        preload: true,
        onloaderror: (_id, error) => {
          console.warn(`Failed to load sound ${name}:`, error);
        },
      });
      this.sounds.set(name, howl);
    }

    await this.loadVoicePack(this.voicePack);
  }

  async loadVoicePack(packName: string): Promise<void> {
    this.voicePack = packName;
    this.voices.clear();

    for (const [name, files] of Object.entries(VOICE_SOUNDS)) {
      const howls: Howl[] = [];
      for (const file of files) {
        const howl = new Howl({
          src: [`/sounds/${packName}/${file}`],
          volume: this.voiceVolume * this.masterVolume,
          preload: true,
          onloaderror: (_id, error) => {
            console.warn(`Failed to load voice ${packName}/${file}:`, error);
          },
        });
        howls.push(howl);
      }
      this.voices.set(name, howls);
    }
  }

  resetFirstBlood(): void {
    this.firstBloodPlayed = false;
  }

  play(name: string): number | null {
    if (!this.enabled) return null;

    const sound = this.sounds.get(name);
    if (!sound) {
      console.warn(`Sound not found: ${name}`);
      return null;
    }

    return sound.play();
  }

  playRandom(names: string[]): number | null {
    if (!this.enabled || names.length === 0) return null;
    const name = names[Math.floor(Math.random() * names.length)];
    return this.play(name);
  }

  playExplosion(): number | null {
    return this.playRandom(['explosion1', 'explosion2', 'explosion3']);
  }

  playVoice(name: string): number | null {
    if (!this.enabled) return null;

    const voiceHowls = this.voices.get(name);
    if (!voiceHowls || voiceHowls.length === 0) {
      console.warn(`Voice not found: ${name}`);
      return null;
    }

    const howl = voiceHowls[Math.floor(Math.random() * voiceHowls.length)];
    return howl.play();
  }

  playRandomVoice(names: string[]): number | null {
    if (!this.enabled || names.length === 0) return null;
    const name = names[Math.floor(Math.random() * names.length)];
    return this.playVoice(name);
  }

  playTurnStart(): void {
    this.play('turnStart');
    setTimeout(() => {
      this.playRandomVoice(['hello', 'yessir', 'orders', 'comeonthen', 'watchthis', 'illgetyou']);
    }, 300);
  }

  playDamage(): void {
    this.playRandomVoice(['ow', 'ouch', 'ooff']);
  }

  playDeath(): void {
    if (!this.firstBloodPlayed) {
      this.firstBloodPlayed = true;
      this.playVoice('firstblood');
    } else {
      this.playRandomVoice(['byebye', 'nooo', 'ohdear', 'uhoh']);
    }
  }

  playVictory(): void {
    this.playRandomVoice([
      'victory',
      'excellent',
      'perfect',
      'amazing',
      'brilliant',
      'flawless',
      'fatality',
    ]);
  }

  playMissed(): void {
    this.playRandomVoice(['missed', 'boring', 'oops', 'bummer', 'stupid']);
  }

  playHurry(): void {
    this.playVoice('hurry');
  }

  playIncoming(): void {
    this.playRandomVoice(['incoming', 'takecover', 'runaway']);
  }

  playLaugh(): void {
    this.playVoice('laugh');
  }

  playTaunt(): void {
    this.playRandomVoice([
      'coward',
      'traitor',
      'revenge',
      'justyouwait',
      'youllregretthat',
      'goaway',
      'leavemealone',
      'oinutter',
    ]);
  }

  playJump(): void {
    this.play('wormJump');
    this.playRandomVoice(['jump1', 'jump2']);
  }

  stop(name: string, id?: number): void {
    const sound = this.sounds.get(name);
    if (sound) {
      if (id !== undefined) {
        sound.stop(id);
      } else {
        sound.stop();
      }
    }
  }

  setVolume(name: string, volume: number, id?: number): void {
    const sound = this.sounds.get(name);
    if (sound) {
      if (id !== undefined) {
        sound.volume(volume * this.masterVolume, id);
      } else {
        sound.volume(volume * this.masterVolume);
      }
    }
  }

  setMasterVolume(volume: number): void {
    this.masterVolume = Math.max(0, Math.min(1, volume));
    Howler.volume(this.masterVolume);
    this.saveSettings();
  }

  getMasterVolume(): number {
    return this.masterVolume;
  }

  getVoiceVolume(): number {
    return this.voiceVolume;
  }

  setVoiceVolume(volume: number): void {
    this.voiceVolume = Math.max(0, Math.min(1, volume));
    for (const howls of this.voices.values()) {
      for (const howl of howls) {
        howl.volume(this.voiceVolume * this.masterVolume);
      }
    }
    this.saveSettings();
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
    if (!enabled) {
      this.stopAll();
    }
    this.saveSettings();
  }

  isEnabled(): boolean {
    return this.enabled;
  }

  stopAll(): void {
    for (const sound of this.sounds.values()) {
      sound.stop();
    }
    for (const howls of this.voices.values()) {
      for (const howl of howls) {
        howl.stop();
      }
    }
  }

  mute(): void {
    Howler.mute(true);
  }

  unmute(): void {
    Howler.mute(false);
  }
}

export const soundManager = new SoundManager();
